import React from "react";
import { usePatientAuthFlags } from "../../Hooks/usePatientAuthFlags";
import CreVideoRecording from "./CreVideoRecording";
import ZikaronVideoRecording from "./ZikaronVideoRecording";

/**
 * Video Recording tab — routes CRE users to MedClip + CRE Video API,
 * all other auth sources to the existing Zikaron integration.
 */
const VideoRecording = () => {
  const { isCreAuth } = usePatientAuthFlags();

  if (isCreAuth) {
    return <CreVideoRecording />;
  }

  return <ZikaronVideoRecording />;
};

export default VideoRecording;
